import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IconButton = (props) => {
	const buttonClassName = classnames({
		"c-button": true,
		"c-icon-button": true,
		[props.className]: props.className,
		"c-button--selected": props.selected,
		"c-button--disabled": props.disabled,
		"c-button--small": props.small
	});

	const content = <FontAwesomeIcon icon={props.icon} />;

	let buttonProps = {
		title: props.title,
		type: "button",
		autoFocus: props.autoFocus,
		className: buttonClassName,
		disabled: props.disabled,
		onClick: props.onClick,
		selected: props.selected
	};

	if (props.style) {
		buttonProps.style = props.style;
	}

	return (
		<button {...buttonProps}>
			{content}
		</button>);
};

IconButton.propTypes = {
	onClick: PropTypes.func,
	icon: PropTypes.object.isRequired,
	className: PropTypes.string,
	title: PropTypes.string,
	selected: PropTypes.bool,
	disabled: PropTypes.bool,
	children: PropTypes.node,
	autoFocus: PropTypes.bool,
	style: PropTypes.object,
	small: PropTypes.bool
};

export default IconButton;
